// extracted by mini-css-extract-plugin
export default {"social-share-buttons":"RSvY1","socialShareButtons":"RSvY1","social-share-group":"MS2Bl","socialShareGroup":"MS2Bl","social-share-button":"ODsdO","socialShareButton":"ODsdO"};